import React from 'react';
import { extend } from '@thd-nucleus/data-sources';
import { AisleBayPodsDataProvider } from '../components/aisleBayPod/AisleBayPodsDataProvider';
import { useSearchContext } from '../hooks/useSearchContext';

const AisleBayPodsDataProviderComposable = ({ children }) => {
    const { data, storeSkuIds, isPLPSearchPage, hasInStoreFilter } = useSearchContext();

    return (
        <AisleBayPodsDataProvider
            storeSkuIds={storeSkuIds}
            isSearchPage={isPLPSearchPage}
            hasInStoreFilter={hasInStoreFilter(data)}
        >{children}
        </AisleBayPodsDataProvider>
    );
};

AisleBayPodsDataProviderComposable.displayName = 'AisleBayPodsDataProviderComposable';

AisleBayPodsDataProviderComposable.dataModel = extend({}, useSearchContext, AisleBayPodsDataProvider);

export { AisleBayPodsDataProviderComposable };
